import { rowHtml } from "../components";
import { fmtCompact } from "../kit";
import { trophiesGlyph } from "../hub/eventRewards";

/**
 * The end screens' Trophies row (MP-23): the painted token, "+40", "Trophies" and where they go — a fact like the Marks
 * row beside it, never an offer (nothing on the end screen opens the Trophy Hall). Markup only.
 */
export function trophyGainRowHtml(n: number, px: number): string {
  if (n <= 0) return "";
  return rowHtml({ lead: trophiesGlyph(px), title: `+${fmtCompact(n)}`, sub: n === 1 ? "Trophy" : "Trophies", end: "<small>for the Trophy Hall</small>", compact: true, className: "erow trophies gain" });
}
